import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { PageHeader } from '../../lib/page-header'

export type SupportPageHeaderProps = {
    className?: ClassName
    style?: React.CSSProperties
}

function SupportPageHeader({ className, style }: SupportPageHeaderProps): React.ReactElement {
    const MENU_LINKS = [
        { href: '/dashboard', labelCode: 'btnDashboard' },
        { href: '/chargepoints', labelCode: 'btnChargers' },
        { href: '/partners', labelCode: 'btnPartners' },
        {
            href: '/companies',
            labelCode: 'btnOrganisations',
        },
        { href: '/users', labelCode: 'btnUsers' },
        { href: '/firmware', labelCode: 'btnFirmwareShort' },
        {
            href: '/loadbalancer',
            labelCode: 'lblLoadbalancerGroups',
        },
        { href: '/measurementDevices', labelCode: 'btnMeasurementDevices' },
        { href: '/operator-changes', labelCode: 'btnOperatorChanges' },
        {
            labelCode: 'btnIntegrations',
            subMenu: [
                { href: '/eapi', labelCode: 'btnEapi' },
                { href: '/externalservers', labelCode: 'btnProxyRelay' },
            ],
        },
    ]

    return <PageHeader className={cn(className)} style={style} links={MENU_LINKS} />
}

export default SupportPageHeader
